import { defineStore } from 'pinia';
import { BasicMentorTitle } from '../root/root-types';

export const useListStore = defineStore({
  id: 'mentorListStore',

  state: () => ({
    mentorTitles: [] as BasicMentorTitle[],
    trafficAllowedJobTitles: [] as BasicMentorTitle[],
  }),

  actions: {
    setMentorTitles(value: BasicMentorTitle[]): void {
      this.mentorTitles = value;
    },
    setTrafficAllowedMentorTitles(value: BasicMentorTitle[]): void {
      this.trafficAllowedJobTitles = value;
    },
  },
});
